import styled from "styled-components";

export const Container = styled.div`display: flex; flex-direction: column; height: 100%; background: #FFF; font-family: Mulish;`;
export const Header = styled.div`display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 16px 18px 12px;`;
export const Title = styled.span`color: #2B3240; font-size: 0.95rem; font-weight: 800;`;
export const Count = styled.span`color: #9AA4B2; font-weight: 700;`;
export const InviteBtn = styled.button`
    border: none; background: #2F80ED; color: #FFF; font-family: Mulish; font-size: 0.78rem; font-weight: 700;
    padding: 7px 12px; border-radius: 8px; cursor: pointer;
    &:disabled { cursor: not-allowed; opacity: 0.6; }
`;
export const Search = styled.div`padding: 0 16px 12px;`;
export const SearchInput = styled.input`
    width: 100%; box-sizing: border-box; border: 1px solid #E3E8F0; border-radius: 8px; padding: 9px 12px;
    font-family: Mulish; font-size: 0.84rem; background: #F7F9FC;
    &:focus { outline: none; border-color: #2F80ED; }
`;
export const Body = styled.div`flex: 1; overflow-y: auto; padding: 0 10px 16px;`;
export const Item = styled.div`
    display: flex; align-items: center; gap: 11px; padding: 10px 10px; border-radius: 10px; cursor: pointer;
    background: ${(p) => (p.$active ? "#EAF2FE" : "transparent")};
    &:hover { background: ${(p) => (p.$active ? "#EAF2FE" : "#F5F7FB")}; }
`;
export const Avatar = styled.div`
    flex: 0 0 auto; width: 40px; height: 40px; border-radius: 50%; background: ${(p) => p.$color || "#2F80ED"};
    color: #FFF; font-weight: 800; font-size: 0.86rem; display: flex; align-items: center; justify-content: center;
`;
export const Info = styled.div`flex: 1; min-width: 0; display: flex; flex-direction: column;`;
export const Name = styled.span`font-size: 0.86rem; font-weight: 700; color: #2B3240;`;
export const Email = styled.span`font-size: 0.74rem; color: #9AA4B2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;`;
export const Meta = styled.div`display: flex; align-items: center; gap: 6px; margin-top: 2px; font-size: 0.72rem; color: #9AA4B2;`;
export const Badge = styled.span`
    background: ${(p) => (p.$role === "owner" ? "#FEF3C7" : "#EAF2FE")}; color: ${(p) => (p.$role === "owner" ? "#B45309" : "#2F80ED")};
    font-size: 0.68rem; font-weight: 800; padding: 2px 8px; border-radius: 8px;
`;
export const State = styled.div`padding: 24px 16px; text-align: center; color: #9AA4B2; font-size: 0.84rem;`;
